// extracted by mini-css-extract-plugin
module.exports = {"dragReorderItem":"DragReorder_dragReorderItem__CVWUM","dragHandle":"DragReorder_dragHandle__yrVIZ"};